import { useContext, useEffect, useState } from "react";
import { AdminDashboardContext } from "../../../../../context/AdminDashboardContext";
import "./ProjectInfoButton.css";

const ProjectInfoButton = ({ projectInfo }) => {
  const [isSelected, setIsSelected] = useState(false);

  const {
    setSelectedProject,
    selectedProjectId,
    setSelectedProjectId,
    editingInProgress,
    setModalUpdateProjectInfoIsOpen,
  } = useContext(AdminDashboardContext);

  const handleClick = () => {
    if (editingInProgress === false) {
      setSelectedProject(projectInfo);
      setSelectedProjectId(projectInfo.id);
      setIsSelected(true);
    } else if (editingInProgress === true && isSelected === false) {
      setModalUpdateProjectInfoIsOpen(true);
      setSelectedProjectId(projectInfo.id);
      setIsSelected(true);
    }
  };

  useEffect(() => {
    if (selectedProjectId === projectInfo.id) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [selectedProjectId, projectInfo.id]);

  return (
    <>
      <button
        className={
          isSelected ? "project-info-button-is-selected" : "project-info-button"
        }
        onClick={handleClick}
      >
        <span>
          {projectInfo.nameSurname} - {projectInfo.projectAcronym}{" "}
        </span>
      </button>
    </>
  );
};

export default ProjectInfoButton;
